function ToolGroupComponent (props) {
    return(
        <div className='tool-group'>
            <h4 className='tool-group-title'>{props.groupName}</h4>
            <div className='tool-group-tags'>
                {props.tools.map((tool, index) => {
                    return <span className='tool-tag' key={index}>{tool}</span>
                })}
            </div>
        </div>
    );
}

export default ToolGroupComponent;
